import React, { useState } from 'react';
import { ButtonIcon, OutlinedButton } from '@prisjakt/ui/button/variants';
import { IconDropdownDown } from '@prisjakt/ui/icon/dropdown-down';
import { IconDropdownUp } from '@prisjakt/ui/icon/dropdown-up';
import { Behavior, TitleSmallText } from '@prisjakt/ui/text/variants';
import { Modal } from 'src/areas/product/styles';
import { useAppContext } from 'src/components/app-context';
import { useOfferListFilterContext } from '../offer-list-filter-context';
import { getVariantSelections } from './utils';
import { IFilterComponent } from './types';
import { IconImageText, ModalInner } from './styles';
import { SelectionHighlightedText } from '../product-variants/styles-common';

export const ModalView: React.FC<IModalView> = props => {
  const { components } = props;
  const { market, t } = useAppContext();
  const { getFilter } = useOfferListFilterContext();
  const selections = getVariantSelections(t, getFilter);
  const [visible, setVisible] = useState<boolean>(false);

  const closeHandler = () => setVisible(false);
  const toggleHandler = () => setVisible(!visible);

  const renderButtonLabel = () => {
    const singleComponentWithCustomButton =
      components.length === 1 && components[0].buttonLabelComponent;

    if (singleComponentWithCustomButton) {
      // For single variant selection
      return (
        <>
          {singleComponentWithCustomButton}
          <ButtonIcon>
            {visible ? <IconDropdownUp /> : <IconDropdownDown />}
          </ButtonIcon>
        </>
      );
    }
    return (
      <IconImageText>
        <img
          src={`${market.cdn}/g/rfe/illustrations/icon-color-wheel-20x20px.png`}
          srcSet={`${market.cdn}/g/rfe/illustrations/icon-color-wheel-20x20px.png 1x, ${market.cdn}/g/rfe/illustrations/icon-color-wheel-40x40px.png 2x`}
          alt=""
        />
        <TitleSmallText behavior={Behavior.OnelineEllipsis}>
          {t('product', 'variants.select-variants')}
          {Boolean(selections) && (
            <SelectionHighlightedText> ({selections})</SelectionHighlightedText>
          )}
        </TitleSmallText>
      </IconImageText>
    );
  };

  return (
    <>
      <OutlinedButton onClick={toggleHandler} fullWidth selectable>
        {renderButtonLabel()}
      </OutlinedButton>

      {visible && (
        <Modal
          isOpen
          onRequestClose={closeHandler}
          shouldShowCloseIcon
          verticalScroll
          width={526}
        >
          <ModalInner>
            {components.map(component => (
              <div key={component.key}>{component.selectorComponent}</div>
            ))}
          </ModalInner>
        </Modal>
      )}
    </>
  );
};

interface IModalView {
  components: IFilterComponent[];
}
